module.exports = __webpack_public_path__ + "img/nt113-02-81-1.prt.835e95c9.jpg";